/**
 * F-148: which kind of video a board is, readable across a column at a
 * glance. Every board carries one — a Short AND a long-form video — because
 * a tag only one kind wears asks the reader to notice an absence. Three cues
 * that each work alone: the word, the shape of the glyph (a portrait phone
 * screen vs a landscape one), and a fill colour kept clear of the five stage
 * colours.
 */
import type { BoardKind } from "@kola/shared";

export function KindBadge({ kind, slots = 1 }: { kind: BoardKind; slots?: number }) {
  const short = kind === "shorts";
  return (
    <span className={`kind-badge ${short ? "kind-badge-short" : "kind-badge-long"}`}>
      <KindGlyph kind={kind} />
      {short ? (slots > 1 ? "Shorts" : "Short") : "Long-form"}
    </span>
  );
}

/** The bare glyph — the kind filter's buttons wear it too. */
export function KindGlyph({ kind }: { kind: BoardKind }) {
  return <span className={`kind-glyph ${kind === "shorts" ? "kind-glyph-short" : "kind-glyph-long"}`} aria-hidden />;
}
